export const TEMPLATE_ENGINE_ALLOWED_SCREENS = new Set<string>([
  'SitesScreen',
  'SiteScreen',
  'AgentVoicesChildTemplatesScreen',
  'EnvironmentsScreen',
  'EnvironmentsChildTemplatesScreen',
  'RealTimeConfigFormScreen',
  'NumbersScreen',
  'SmartAnalystScreen',
  'ConversationsScreen',
  'ConversationReviewScreen',
  'LatestConversationRedirect',
  'HomePageScreen',
  'StandardDashboardScreen',
  'CustomAnalyticsDashboardScreen',
  'HomePageScreen',
  'QSAnalyticsDashboardScreen',
  'ChildProjectIntegrationsScreen',
] as const);

export function isTemplateEngineScreenAllowed(screenKey: string): boolean {
  return TEMPLATE_ENGINE_ALLOWED_SCREENS.has(screenKey);
}
